// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__SPZ2w","comment":"styles_comment__2i3W3"};